/* פאפוס — מגירת עגלה: לוגיקה */
(function () {
  var root = document.getElementById('PaphosCartDrawer');
  if (!root) return;
  var cfg = JSON.parse(document.getElementById('PaphosCartDrawerData').textContent);
  cfg.gifts = (cfg.gifts || []).filter(Boolean).map(function (g) { g.tier = +g.tier; return g; });
  var body = root.querySelector('.pcd-body');
  var itemsEl = root.querySelector('.pcd-items');
  var giftGrid = root.querySelector('.pcd-gift-grid');
  var giftsBox = root.querySelector('.pcd-gifts');
  var progressText = root.querySelector('.pcd-progress-text');
  var barFill = root.querySelector('.pcd-bar-fill');
  var marks = root.querySelectorAll('.pcd-mark');
  var sumTotal = root.querySelector('[data-sum-total]');
  var titleEl = root.querySelector('.pcd-title');
  var addonToggle = root.querySelector('.pcd-toggle input');
  var addonBox = root.querySelector('.pcd-addon');
  var cart = null;
  var busy = false;
  var tagCache = {};
  var cartTagSet = {};

  var prodCache = {};
  function normTag(s) { return String(s).toLowerCase().replace(/[’׳]/g, "'").trim(); }
  function loadCartTags() {
    var handles = [];
    cart.items.forEach(function (it) {
      if (isGift(it) || isAddon(it)) return;
      if (handles.indexOf(it.handle) === -1) handles.push(it.handle);
    });
    return Promise.all(handles.map(function (h) {
      if (tagCache[h]) return Promise.resolve();
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { tagCache[h] = p.tags || []; prodCache[h] = p; })
        .catch(function () { tagCache[h] = []; });
    })).then(function () {
      cartTagSet = {};
      handles.forEach(function (h) {
        (tagCache[h] || []).forEach(function (t) { cartTagSet[normTag(t)] = true; });
      });
    });
  }
  function giftEligible(g) {
    return !g.tag || cartTagSet[normTag(g.tag)];
  }

  function fmt(cents) {
    var v = cents / 100;
    return '₪' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function isGift(item) { return item.properties && item.properties._paphos_gift; }
  function isAddon(item) { return item.properties && item.properties._paphos_addon; }
  function isBundle(item) { return item.properties && item.properties._paphos_bundle; }
  function paidTotal() {
    return cart.items.reduce(function (s, it) {
      /* מתנת השבוע היא כבר מתנה — היא לא נספרת לכיוון מדרגות המתנות החינם */
      return (isGift(it) || isAddon(it)) ? s : s + it.final_line_price;
    }, 0);
  }
  function currentTier() {
    var t = paidTotal() / 100;
    if (t >= cfg.t3) return 3;
    if (t >= cfg.t2) return 2;
    if (t >= cfg.t1) return 1;
    return 0;
  }
  function giftLines() {
    return cart.items.filter(isGift);
  }
  function maxGifts() { return currentTier(); }

  /* ---- רינדור ---- */
  function render() {
    root.classList.toggle('is-empty', cart.item_count === 0);
    if (cart.item_count === 0) titleEl.textContent = 'העגלה שלך';
    else if (cart.item_count === 1) titleEl.innerHTML = 'יש לך <strong>פריט אחד</strong> בעגלה';
    else titleEl.innerHTML = 'יש לך <strong>' + cart.item_count + ' פריטים</strong> בעגלה';
    renderItems();
    renderGifts();
    renderDeals();
    renderProgress();
    renderSummary();
    syncAddonToggle();
    syncHeaderBubble();
  }

  function renderItems() {
    itemsEl.innerHTML = '';
    /* מיפוי: איזו מתנה שייכת לאיזה מוצר */
    var giftOwner = {};
    cart.items.forEach(function (it) {
      if (isGift(it) || isAddon(it) || isBundle(it)) return;
      itemGiftHandles(it).forEach(function (h) {
        if (!giftOwner[h]) giftOwner[h] = { handle: it.handle, title: it.product_title };
      });
    });
    /* סדר תצוגה: כל מוצר ואחריו המתנות הצמודות שלו */
    var order = [];
    var bundlesOf = {};
    cart.items.forEach(function (it, idx) {
      if (isBundle(it) && giftOwner[it.handle]) {
        var ow = giftOwner[it.handle].handle;
        (bundlesOf[ow] = bundlesOf[ow] || []).push({ it: it, idx: idx });
        return;
      }
      order.push({ it: it, idx: idx });
    });
    /* התוספת תמיד אחרונה — היא נוספת ממתג ולא מדף מוצר */
    order.sort(function (a, b) { return (isAddon(a.it) ? 1 : 0) - (isAddon(b.it) ? 1 : 0); });
    var display = [];
    order.forEach(function (e) {
      display.push(e);
      (bundlesOf[e.it.handle] || []).forEach(function (b) { display.push(b); });
    });
    display.forEach(function (entry) {
      var it = entry.it, idx = entry.idx;
      /* התוספת מוצגת כשורה רגילה בעגלה, עם תווית משלה ובלי בורר כמות */
      var addonish = isAddon(it);
      var giftish = isGift(it) || isBundle(it);
      var dealTag = (cfg.deals && cfg.deals.tag) || 'הנחה';
      var isDealLine = !giftish && (tagCache[it.handle] || []).some(function (t) { return normTag(t) === normTag(dealTag); });
      var dealCompare = 0;
      if (isDealLine && prodCache[it.handle]) {
        var dv = (prodCache[it.handle].variants || []).find(function (x) { return String(x.id) === String(it.variant_id); });
        if (dv && dv.compare_at_price > dv.price) dealCompare = dv.compare_at_price * it.quantity;
      }
      var owner = isBundle(it) ? giftOwner[it.handle] : null;
      var el = document.createElement('div');
      el.className = 'pcd-item' + (giftish ? ' is-gift' : '') + (addonish ? ' is-addon-line' : '') + (owner ? ' is-bundle-child' : '');
      /* לתוספת אין תמיד תמונת מוצר — נופלים לתמונת ההסבר כדי שהשורה תיראה כמו כל מוצר */
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : (addonish ? (cfg.addon && cfg.addon.image) || '' : '');
      var giftMeta = isGift(it) ? cfg.gifts.find(function (x) { return String(x.variant) === String(it.variant_id); }) : null;
      var giftWorth = Math.max(it.original_line_price, giftMeta ? giftMeta.price : 0);
      if (isBundle(it) && prodCache[it.handle]) {
        var bv = (prodCache[it.handle].variants || []).find(function (x) { return String(x.id) === String(it.variant_id); });
        if (bv && bv.compare_at_price) giftWorth = Math.max(giftWorth, bv.compare_at_price);
      }
      var priceHtml = giftish && it.final_line_price === 0
        ? fmt(0) + (giftWorth > 0 ? '<span class="was">' + fmt(giftWorth) + '</span>' : '')
        : fmt(it.final_line_price) + (it.final_line_price < it.original_line_price ? '<span class="was">' + fmt(it.original_line_price) + '</span>' : '');
      var dealOff = 0;
      if (dealCompare > it.final_line_price) {
        dealOff = Math.round((1 - it.final_line_price / dealCompare) * 100);
        priceHtml = fmt(it.final_line_price) + '<span class="was">' + fmt(dealCompare) + '</span>';
      }
      el.innerHTML =
        (img ? '<img class="pcd-item-img" src="' + img + '" alt="">' : '<div class="pcd-item-img"></div>') +
        '<div class="pcd-item-main">' +
          (isDealLine ? '<span class="pcd-deal-chip">🔥 מוצר בהנחה משמעותית' + (dealOff ? ' · ' + dealOff + '%-' : '') + '</span>' : '') +
          (addonish ? '<span class="pcd-gift-chip-row"><span class="pcd-addon-chip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="4"/><rect x="5" y="12" width="14" height="9"/><path d="M12 8v13M12 8s-4 .3-5-1.5C6 5 7 3.5 8.5 3.5c2 0 3.5 2.5 3.5 4.5zM12 8s4 .3 5-1.5C18 5 17 3.5 15.5 3.5c-2 0-3.5 2.5-3.5 4.5z"/></svg>' + ((cfg.addon && cfg.addon.title) || 'תוספת') + '</span></span>' : '') +
          (giftish ? '<span class="pcd-gift-chip-row"><span class="pcd-gift-chip"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="4"/><rect x="5" y="12" width="14" height="9"/><path d="M12 8v13M12 8s-4 .3-5-1.5C6 5 7 3.5 8.5 3.5c2 0 3.5 2.5 3.5 4.5zM12 8s4 .3 5-1.5C18 5 17 3.5 15.5 3.5c-2 0-3.5 2.5-3.5 4.5z"/></svg>מתנה</span>' + (isBundle(it) ? '<button class="pcd-item-info" type="button" data-binfo="' + it.handle + '" aria-label="מידע על המתנה"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M16.5 16.5L21 21M11 8v.01M11 11v3.5"/></svg></button>' : '') + (owner ? '<span class="pcd-gift-because">כי רכשת: ' + String(owner.title).slice(0, 26) + (String(owner.title).length > 26 ? '…' : '') + '</span>' : '') + '</span>' : '') +
          (addonish
            ? ((cfg.addon && cfg.addon.lead) ? '<p class="pcd-item-variant">' + cfg.addon.lead + '</p>' : '')
            : '<h4 class="pcd-item-title">' + it.product_title + '</h4>') +
          (it.variant_title && it.variant_title !== 'Default Title' ? '<p class="pcd-item-variant">' + it.variant_title + '</p>' : '') +
          '<div class="pcd-item-bottom">' +
            (addonish ? '' : giftish ? '<span class="pcd-gift-free-lbl">חינם</span>' :
              '<div class="pcd-qty">' +
                '<button data-plus="' + (idx + 1) + '" aria-label="הוספה">+</button>' +
                '<span>' + it.quantity + '</span>' +
                '<button data-minus="' + (idx + 1) + '" aria-label="הפחתה">−</button>' +
              '</div>') +
            '<span class="pcd-item-price">' + priceHtml + '</span>' +
          '</div>' +
        '</div>' +
        (isBundle(it) ? '<button class="pcd-item-remove" data-bremove="' + it.key + '" data-bhandle="' + it.handle + '" aria-label="הסרת המתנה">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6.5 7l1 13h9l1-13M10 11v6M14 11v6"/></svg>' +
          '<span>מחק</span>' +
        '</button>' :
        '<button class="pcd-item-remove" data-remove="' + (idx + 1) + '" aria-label="מחיקת הפריט מהעגלה">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6.5 7l1 13h9l1-13M10 11v6M14 11v6"/></svg>' +
          '<span>מחק</span>' +
        '</button>');
      itemsEl.appendChild(el);
    });
  }

  function renderGifts() {
    var tier = currentTier();
    var eligible = cfg.gifts.filter(giftEligible);
    giftsBox.style.display = eligible.length ? '' : 'none';
    root.querySelector('.pcd-progress').style.display = eligible.length ? '' : 'none';
    var selVars = giftLines().map(function (l) { return String(l.variant_id); });
    var max = maxGifts();
    var sub = root.querySelector('.pcd-gifts-sub');
    if (max === 0) sub.textContent = 'המתנות נפתחות בקנייה מעל ₪' + cfg.t1;
    else sub.innerHTML = 'בחרת <strong>' + selVars.length + ' מתוך ' + max + '</strong> מתנות שמגיעות לך';
    giftGrid.innerHTML = '';
    eligible.forEach(function (g) {
      var locked = tier < g.tier;
      var selected = selVars.indexOf(String(g.variant)) !== -1;
      var full = !locked && !selected && selVars.length >= max;
      var card = document.createElement('div');
      card.className = 'pcd-gift-card' + (locked ? ' is-locked' : '') + (selected ? ' is-selected' : '') + (full ? ' is-full' : '');
      card.innerHTML =
        (locked
          ? '<span class="pcd-gift-lock"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg></span>'
          : '<span class="pcd-gift-add">' + (selected ? '✓' : '+') + '</span>') +
        '<span class="pcd-gift-info" data-info aria-label="מידע על המתנה"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M16.5 16.5L21 21M11 8v.01M11 11v3.5"/></svg></span>' +
        '<img src="' + g.image + '" alt="" loading="lazy">' +
        '<span class="name">' + g.title + '</span>' +
        (locked
          ? '<span class="pcd-gift-tier-tag">נפתח ב-₪' + cfg['t' + g.tier] + '</span>'
          : '<span class="worth"><span>שווי</span><span class="worth-amt">' + fmt(g.price) + '</span></span>');
      card.addEventListener('click', function () {
        if (selected) { removeGift(g); }
        else if (locked || full) { openGiftPopup(g); }
        else { addGift(g); }
      });
      card.querySelector('[data-info]').addEventListener('click', function (e) {
        e.stopPropagation();
        openGiftPopup(g);
      });
      giftGrid.appendChild(card);
    });
  }

  /* ---- מוצרים נבחרים בהנחה ---- */
  var dealsData = null, dealsFetchedAt = 0;
  function dealsVisible() {
    var dl = cfg.deals || {};
    if (!dl.col && !(dl.list && dl.list.length)) return false;
    if (dl.showTag && !cartTagSet[normTag(dl.showTag)]) return false;
    if (dl.hideTag && cartTagSet[normTag(dl.hideTag)]) return false;
    return true;
  }
  function renderDeals() {
    var box = root.querySelector('[data-deals]');
    if (!box) return;
    if (!dealsVisible()) { box.hidden = true; return; }
    var grid = box.querySelector('[data-deals-grid]');
    var dl = cfg.deals;
    var draw = function (list) {
      /* הרשימה מגיעה מ-fetch אסינכרוני. עד שהיא חוזרת ייתכן שהעגלה כבר
         נטענה עם תגיות שמסתירות את הבלוק — בודקים שוב לפני שמציגים. */
      if (!dealsVisible()) { box.hidden = true; return; }
      var inCartHandles = {};
      cart.items.forEach(function (it) { inCartHandles[it.handle] = true; });
      var items = list.filter(function (p) {
        if (inCartHandles[p.handle]) return false;
        return p.available !== false;
      }).slice(0, dl.count || 4);
      if (!items.length) { box.hidden = true; return; }
      grid.innerHTML = '';
      var loop = items.length > 1;
      var renderList = loop ? items.concat(items, items) : items;
      renderList.forEach(function (p) {
        var off = p.compare > p.price ? Math.round((1 - p.price / p.compare) * 100) : 0;
        var card = document.createElement('div');
        card.className = 'pcd-deal-card';
        card.innerHTML =
          '<span class="pcd-gift-info" data-dinfo aria-label="מידע על המוצר"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M16.5 16.5L21 21M11 8v.01M11 11v3.5"/></svg></span>' +
          (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') +
          '<span class="dl-mid">' +
            '<span class="dl-name">' + p.title + '</span>' +
            '<span class="dl-prices"><span class="dl-price">' + fmt(p.price) + '</span>' +
              (p.compare > p.price ? '<span class="dl-was">' + fmt(p.compare) + '</span>' : '') +
              (off ? '<span class="dl-badge">-' + off + '%</span>' : '') + '</span>' +
          '</span>' +
          '<span class="pcd-gift-add">+</span>';
        card.addEventListener('click', function (e) {
          if (e.target.closest('[data-dinfo]')) { openDealPopup(p); return; }
          if (busy) return;
          busy = true; body.classList.add('pcd-loading');
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: p.variant, quantity: 1 })
          }).then(refresh).catch(refresh);
        });
        grid.appendChild(card);
      });
      box.hidden = false;
      box.classList.toggle('has-nav', loop);
      box.classList.toggle('is-carousel', loop);
      /* קרוסלה אינסופית ממורכזת */
      var N = items.length;
      var wrap = box.querySelector('.pcd-deals-carousel');
      if (!loop) {
        grid.style.transition = 'none';
        grid.style.transform = '';
        return;
      }
      var state = wrap.__dstate = { cur: N, N: N, anim: false };
      function place(animated) {
        var cardEl = grid.querySelector('.pcd-deal-card');
        if (!cardEl) return;
        var cw = cardEl.offsetWidth;
        var gap = 8;
        var t = state.cur * (cw + gap) + cw / 2 - wrap.clientWidth / 2;
        grid.style.transition = animated ? 'transform 0.3s ease' : 'none';
        grid.style.transform = 'translateX(' + t + 'px)';
      }
      function stepTo(dir) {
        if (!loop || state.anim) return;
        state.anim = true;
        state.cur += dir;
        place(true);
        setTimeout(function () {
          if (state.cur >= 2 * N) { state.cur -= N; place(false); }
          if (state.cur < N) { state.cur += N; place(false); }
          state.anim = false;
        }, 320);
      }
      wrap.__dstep = stepTo;
      place(false);
      var prev = box.querySelector('[data-deals-prev]');
      var next = box.querySelector('[data-deals-next]');
      if (prev && !prev.dataset.bound) {
        prev.dataset.bound = next.dataset.bound = '1';
        prev.addEventListener('click', function () { wrap.__dstep && wrap.__dstep(-1); });
        next.addEventListener('click', function () { wrap.__dstep && wrap.__dstep(1); });
        var tx = null;
        wrap.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
        wrap.addEventListener('touchend', function (e) {
          if (tx === null) return;
          var dx = e.changedTouches[0].clientX - tx;
          if (Math.abs(dx) > 35) { wrap.__dstep && wrap.__dstep(dx < 0 ? 1 : -1); }
          tx = null;
        }, { passive: true });
      }
    };
    if (dl.list && dl.list.length) { draw(dl.list); return; }
    var drawFetched = function () {
      draw((dealsData || []).map(function (p) {
        var v = (p.variants || [])[0] || {};
        var tagOk = !dl.tag || (p.tags || []).some(function (t) { return normTag(t) === normTag(dl.tag); });
        return {
          handle: p.handle, title: p.title,
          image: (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '',
          images: (p.images || []).map(function (im) { return im.src || im; }).slice(0, 10),
          variant: v.id,
          price: Math.round(parseFloat(v.price || 0) * 100),
          compare: v.compare_at_price ? Math.round(parseFloat(v.compare_at_price) * 100) : 0,
          available: tagOk && v.available !== false,
          descHtml: p.body_html || ''
        };
      }));
    };
    if (dealsData && Date.now() - dealsFetchedAt < 60000) { drawFetched(); return; }
    fetch('/collections/' + encodeURIComponent(cfg.deals.col) + '/products.json?limit=250')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        dealsData = d.products || [];
        dealsFetchedAt = Date.now();
        drawFetched();
      })
      .catch(function () { box.hidden = true; });
  }

  function renderBundleNote() {
    var note = root.querySelector('[data-bundle-note]');
    if (!note) return;
    var lines = cart.items.filter(isBundle);
    if (!lines.length) { note.hidden = true; note.innerHTML = ''; return; }
    var totalWorth = 0;
    var rows = lines.map(function (l) {
      var worth = 0;
      var p = prodCache[l.handle];
      if (p) {
        var v = (p.variants || []).find(function (x) { return String(x.id) === String(l.variant_id); }) || (p.variants || [])[0];
        if (v && v.compare_at_price) worth = v.compare_at_price;
      }
      if (!worth && l.original_line_price) worth = l.original_line_price;
      totalWorth += worth;
      var img = l.image ? l.image.replace(/(\.[a-z]+)(\?|$)/, '_100x$1$2') : '';
      return '<div class="pcd-bn-gift">' +
        (img ? '<img src="' + img + '" alt="">' : '') +
        '<span class="bn-name">' + l.product_title + '</span>' +
        '<span class="bn-worth">חינם' + (worth ? '<s>' + fmt(worth) + '</s>' : '') + '</span>' +
      '</div>';
    }).join('');
    note.innerHTML =
      '<p class="pcd-bn-head">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="8" width="18" height="4"/><rect x="5" y="12" width="14" height="9"/><path d="M12 8v13M12 8s-4 .3-5-1.5C6 5 7 3.5 8.5 3.5c2 0 3.5 2.5 3.5 4.5zM12 8s4 .3 5-1.5C18 5 17 3.5 15.5 3.5c-2 0-3.5 2.5-3.5 4.5z"/></svg>' +
        'מתנה בכל קנייה!' +
      '</p>' +
      '<p class="pcd-bn-sub">קיבלת מתנה עבור הרכישה שלך' + (totalWorth ? ' בשווי <b>' + fmt(totalWorth) + '</b>' : '') + '</p>' +
      '<div class="pcd-bn-gifts">' + rows + '</div>';
    note.hidden = false;
  }
  function renderProgress() {
    var t = paidTotal() / 100;
    /* מיקום ויזואלי לא-ליניארי: מתנה 1 קרובה, 2 באמצע, 3 בסוף */
    var POS = [32, 64, 100];
    var tiers = [cfg.t1, cfg.t2, cfg.t3];
    var pct;
    if (t <= 0) pct = 0;
    else if (t < tiers[0]) pct = (t / tiers[0]) * POS[0];
    else if (t < tiers[1]) pct = POS[0] + ((t - tiers[0]) / (tiers[1] - tiers[0])) * (POS[1] - POS[0]);
    else if (t < tiers[2]) pct = POS[1] + ((t - tiers[1]) / (tiers[2] - tiers[1])) * (POS[2] - POS[1]);
    else pct = 100;
    barFill.style.setProperty('width', pct + '%', 'important');
    marks.forEach(function (m, i) {
      m.style.right = 'calc(' + POS[i] + '% - 12px)';
      m.classList.toggle('is-hit', t >= tiers[i]);
    });
    var giftSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><rect x="3" y="8" width="18" height="4"/><rect x="5" y="12" width="14" height="9"/><path d="M12 8v13M12 8s-4 .3-5-1.5C6 5 7 3.5 8.5 3.5c2 0 3.5 2.5 3.5 4.5zM12 8s4 .3 5-1.5C18 5 17 3.5 15.5 3.5c-2 0-3.5 2.5-3.5 4.5z"/></svg>';
    var msg;
    if (t >= cfg.t3) msg = giftSvg + '<span><strong>יש לך 3 מתנות לבחירה!</strong></span>';
    else if (t >= cfg.t2) msg = giftSvg + '<span><strong>יש לך 2 מתנות לבחירה</strong> · עוד ₪' + Math.ceil(cfg.t3 - t) + ' לשלישית</span>';
    else if (t >= cfg.t1) msg = giftSvg + '<span><strong>יש לך מתנה לבחירה</strong> · עוד ₪' + Math.ceil(cfg.t2 - t) + ' לשנייה</span>';
    else msg = giftSvg + '<span>הוסיפי עוד <strong>₪' + Math.ceil(cfg.t1 - t) + '</strong> וקבלי מתנה</span>';
    progressText.innerHTML = msg;
  }

  function renderSummary() {
    sumTotal.textContent = fmt(cart.total_price);
  }

  function syncAddonToggle() {
    if (!addonBox || !addonToggle) return;
    if (!cfg.addon.variant) { addonBox.style.display = 'none'; return; }
    var has = cart.items.some(isAddon);
    addonToggle.checked = has;
  }

  function syncHeaderBubble() {
    document.querySelectorAll('.ph-cart-count').forEach(function (b) {
      b.textContent = cart.item_count > 0 ? cart.item_count : '';
    });
  }

  /* ---- פעולות עגלה ---- */
  function api(url, payload) {
    busy = true; body.classList.add('pcd-loading');
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); }).then(refresh)
      .catch(refresh);
  }
  function refresh() {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      cart = c;
      /* ציור ראשון מיד: הלקוחה רואה את הפריט בלי לחכות עוד ~800ms
         לתגיות המוצרים ולחוקי המתנות. הציור השני מתקן אם צריך. */
      body.classList.remove('pcd-loading');
      render();
      return loadCartTags();
    }).then(function () {
      return enforceGiftRules();
    }).then(function () {
      return enforceBundles();
    }).then(function () {
      busy = false; body.classList.remove('pcd-loading');
      render();
      setTimeout(updateScrollHint, 60);
    });
  }
  function enforceGiftRules() {
    var lines = giftLines();
    if (!lines.length) return Promise.resolve();
    var tier = currentTier();
    var ops = [];
    var kept = [];
    lines.forEach(function (l) {
      var meta = cfg.gifts.find(function (x) { return String(x.variant) === String(l.variant_id); });
      if (!meta || tier < meta.tier || !giftEligible(meta)) {
        ops.push({ key: l.key, q: 0 });
      } else {
        if (l.quantity > 1) ops.push({ key: l.key, q: 1 });
        kept.push(l);
      }
    });
    var excess = kept.length - tier;
    while (excess > 0) {
      ops.push({ key: kept[kept.length - excess].key, q: 0 });
      excess--;
    }
    if (!ops.length) return Promise.resolve();
    var chain = Promise.resolve();
    ops.forEach(function (op) {
      chain = chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: op.key, quantity: op.q })
        });
      });
    });
    return chain
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; });
  }
  /* ---- מתנות צמודות למוצר (טאג "מתנה:handle") ---- */
  var bundleFailed = {};
  function bundleDismissed() {
    try { return JSON.parse(sessionStorage.getItem('pphBundleDismissed') || '{}'); } catch (e) { return {}; }
  }
  function saveBundleDismissed(d) {
    try { sessionStorage.setItem('pphBundleDismissed', JSON.stringify(d)); } catch (e) {}
  }
  function tagToGiftHandle(t) {
    var m = String(t).trim().match(/^מתנה\s*:\s*(.+)$/);
    if (!m) return null;
    var h = m[1].trim();
    try { h = decodeURIComponent(h); } catch (e) {}
    /* סלחנות: גם שם מוצר עם רווחים/(Copy) יתורגם ל-handle */
    h = h.replace(/[()"'״׳]/g, ' ').trim().replace(/\s+/g, '-').toLowerCase();
    return h || null;
  }
  function itemGiftHandles(it) {
    var out = [];
    (tagCache[it.handle] || []).forEach(function (t) {
      var h = tagToGiftHandle(t);
      if (h) out.push(h);
    });
    return out;
  }
  function requiredBundles() {
    var req = {};
    cart.items.forEach(function (it) {
      if (isGift(it) || isAddon(it) || isBundle(it)) return;
      itemGiftHandles(it).forEach(function (h) { req[h] = true; });
    });
    return req;
  }
  function enforceBundles() {
    var req = requiredBundles();
    var dismissed = bundleDismissed();
    var dChanged = false;
    Object.keys(dismissed).forEach(function (h) {
      if (!req[h]) { delete dismissed[h]; dChanged = true; }
    });
    if (dChanged) saveBundleDismissed(dismissed);
    var chain = Promise.resolve();
    var dirty = false;
    /* הסרה: מתנה צמודה שהטריגר שלה כבר לא בעגלה, או כפולה */
    var seen = {};
    cart.items.forEach(function (l) {
      if (!isBundle(l)) return;
      var q = null;
      if (!req[l.handle] || seen[l.handle]) q = 0;
      else if (l.quantity > 1) q = 1;
      seen[l.handle] = true;
      if (q !== null) {
        dirty = true;
        chain = chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: l.key, quantity: q })
          });
        });
      }
    });
    /* הוספה: מתנה נדרשת שעוד לא בעגלה */
    Object.keys(req).forEach(function (h) {
      var exists = cart.items.some(function (l) { return isBundle(l) && l.handle === h; });
      if (exists || bundleFailed[h] || dismissed[h]) return;
      dirty = true;
      chain = chain.then(function () {
        return fetch('/products/' + encodeURIComponent(h) + '.js')
          .then(function (r) { if (!r.ok) throw 0; return r.json(); })
          .then(function (p) {
            var v = (p.variants || []).find(function (x) { return x.available; }) || (p.variants || [])[0];
            if (!v) throw 0;
            return fetch('/cart/add.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: v.id, quantity: 1, properties: { _paphos_bundle: '1' } })
            });
          })
          .catch(function () { bundleFailed[h] = true; });
      });
    });
    if (!dirty) return Promise.resolve();
    return chain
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return loadCartTags(); });
  }

  function addGift(g) {
    if (busy || !cart) return;
    busy = true; body.classList.add('pcd-loading');
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: g.variant, quantity: 1, properties: { _paphos_gift: '1' } })
    }).then(refresh).catch(refresh);
  }
  function removeGift(g) {
    if (busy || !cart) return;
    var line = giftLines().find(function (l) { return String(l.variant_id) === String(g.variant); });
    if (!line) return;
    busy = true; body.classList.add('pcd-loading');
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line.key, quantity: 0 })
    }).then(refresh).catch(refresh);
  }

  /* ---- אירועים ---- */
  itemsEl.addEventListener('click', function (e) {
    var binfo = e.target.closest('[data-binfo]');
    if (binfo) { openBundleInfo(binfo.dataset.binfo); return; }
    var brem = e.target.closest('[data-bremove]');
    if (brem) { openBundleRemoveConfirm(brem.dataset.bremove, brem.dataset.bhandle); return; }
    if (busy) return;
    var plus = e.target.closest('[data-plus]');
    var minus = e.target.closest('[data-minus]');
    var rem = e.target.closest('[data-remove]');
    if (plus) changeLine(+plus.dataset.plus, +1);
    else if (minus) changeLine(+minus.dataset.minus, -1);
    else if (rem) removeLine(+rem.dataset.remove);
  });
  function changeLine(line, delta) {
    var it = cart.items[line - 1];
    api('/cart/change.js', { line: line, quantity: Math.max(0, it.quantity + delta) });
  }
  function removeLine(line) {
    api('/cart/change.js', { line: line, quantity: 0 });
  }
  addonToggle && addonToggle.addEventListener('change', function () {
    if (busy) { syncAddonToggle(); return; }
    /* המגירה טוענת את העגלה רק בפתיחה. אם מישהו הגיע למתג לפני כן — טוענים ואז חוזרים. */
    if (!cart) {
      var want = addonToggle.checked;
      busy = true;
      refresh().then(function () { addonToggle.checked = want; addonToggle.dispatchEvent(new Event('change', { bubbles: true })); });
      return;
    }
    var line = cart.items.find(isAddon);
    if (addonToggle.checked && !line) {
      api('/cart/add.js', { id: cfg.addon.variant, quantity: 1, properties: { _paphos_addon: '1' } });
    } else if (!addonToggle.checked && line) {
      api('/cart/change.js', { id: line.key, quantity: 0 });
    }
  });

  /* ---- פופאפ ההסבר של התוספת ----
     נפתח מכפתור ה-ⓘ שליד הכותרת. הכפתור בתוכו מדליק את המתג עצמו,
     כדי שתהיה נקודת הוספה אחת בלבד ולא שני מנגנונים מקבילים. */
  var addonInfoBtn = root.querySelector('[data-addon-info]');
  var addonPop = root.querySelector('[data-addon-pop]');
  if (addonInfoBtn && addonPop) {
    /* למגירה יש transform, וזה כולא כל position:fixed שבתוכה.
       מעבירים את הפופאפ ל-body כדי שיכסה את כל המסך ולא רק את רוחב המגירה. */
    document.body.appendChild(addonPop);
    var addonPopCta = addonPop.querySelector('[data-addon-pop-add]');
    var addonPopDone = addonPop.querySelector('[data-addon-pop-done]');

    function paintAddonCta() {
      if (!addonPopDone || !addonToggle) return;
      addonPopDone.hidden = !addonToggle.checked;
    }
    function openAddonPop() {
      paintAddonCta();
      addonPop.hidden = false;
      document.body.style.overflow = 'hidden';
    }
    function closeAddonPop() {
      addonPop.hidden = true;
      document.body.style.overflow = '';
    }

    addonInfoBtn.addEventListener('click', openAddonPop);
    addonPop.querySelector('[data-addon-pop-x]').addEventListener('click', closeAddonPop);
    addonPop.addEventListener('click', function (e) { if (e.target === addonPop) closeAddonPop(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !addonPop.hidden) closeAddonPop();
    });
    /* לחיצה על התמונה = הדלקת המתג. אם כבר דלוק — רק סוגרים, בלי לכבות בטעות. */
    addonPopCta && addonPopCta.addEventListener('click', function () {
      if (busy) return;
      if (!addonToggle.checked) {
        addonToggle.checked = true;
        addonToggle.dispatchEvent(new Event('change', { bubbles: true }));
        paintAddonCta();
        setTimeout(closeAddonPop, 700);
      } else {
        closeAddonPop();
      }
    });
    /* המתג עשוי להשתנות גם מחוץ לפופאפ — משקפים */
    addonToggle && addonToggle.addEventListener('change', paintAddonCta);
  }

  /* ---- פופאפ מתנה ---- */
  var gpop = root.querySelector('.pcd-gpop');
  var gpopSelect = gpop.querySelector('.pcd-gpop-select');
  var gpopCurrent = null;
  function openGiftPopup(g) {
    gpopCurrent = g;
    var sec0 = gpop.querySelector('.pcd-gpop-secondary');
    if (sec0) sec0.hidden = true;
    var th = gpop.querySelector('.pcd-gpop-thumbs');
    if (th) { th.hidden = true; th.innerHTML = ''; }
    gpop.querySelector('.pcd-gpop-desc').classList.remove('is-rich');
    gpop.querySelector('.pcd-gpop-img').src = g.imageBig || g.image;
    gpop.querySelector('.pcd-gpop-title').textContent = g.title;
    gpop.querySelector('.pcd-gpop-worth').textContent = g.price > 0 ? 'מתנה בשווי ' + fmt(g.price) : 'מתנה חינם';
    gpop.querySelector('.pcd-gpop-desc').textContent = g.desc || '';
    var selected = giftLines().some(function (l) { return String(l.variant_id) === String(g.variant); });
    var locked = currentTier() < g.tier;
    var full = !selected && giftLines().length >= maxGifts();
    if (locked) { gpopSelect.textContent = 'נפתחת בקנייה מעל ₪' + cfg['t' + g.tier]; gpopSelect.disabled = true; }
    else if (selected) { gpopSelect.textContent = 'הסירי את המתנה'; gpopSelect.disabled = false; }
    else if (full) { gpopSelect.textContent = 'בחרת כבר את כל המתנות שלך'; gpopSelect.disabled = true; }
    else { gpopSelect.textContent = 'אני רוצה את המתנה הזו'; gpopSelect.disabled = false; }
    gpop.hidden = false;
  }
  function sanitizeHtml(html) {
    var tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    tmp.querySelectorAll('script, style, iframe, link, form').forEach(function (el) { el.remove(); });
    tmp.querySelectorAll('*').forEach(function (el) {
      [].slice.call(el.attributes).forEach(function (a) {
        if (/^on/i.test(a.name)) el.removeAttribute(a.name);
      });
    });
    return tmp.innerHTML;
  }
  function openDealPopup(p) {
    gpopCurrent = { __deal: p };
    var sec1 = gpop.querySelector('.pcd-gpop-secondary');
    if (sec1) sec1.hidden = true;
    var mainImg = gpop.querySelector('.pcd-gpop-img');
    mainImg.src = p.image || '';
    gpop.querySelector('.pcd-gpop-title').textContent = p.title;
    var off = p.compare > p.price ? Math.round((1 - p.price / p.compare) * 100) : 0;
    gpop.querySelector('.pcd-gpop-worth').textContent = off
      ? '🔥 הנחה משמעותית! ' + fmt(p.price) + ' במקום ' + fmt(p.compare) + ' (' + off + '%-)'
      : fmt(p.price);
    var desc = gpop.querySelector('.pcd-gpop-desc');
    desc.innerHTML = sanitizeHtml(p.descHtml || p.desc || '');
    desc.classList.add('is-rich');
    /* גלריית ממוזערות */
    var thumbs = gpop.querySelector('.pcd-gpop-thumbs');
    thumbs.innerHTML = '';
    var imgs = (p.images || []).length ? p.images : (p.image ? [p.image] : []);
    if (imgs.length > 1) {
      imgs.forEach(function (src, i) {
        var t = document.createElement('img');
        t.src = src.replace(/(\.[a-z]+)(\?|$)/, '_100x$1$2');
        t.className = i === 0 ? 'is-active' : '';
        t.addEventListener('click', function () {
          mainImg.src = src;
          thumbs.querySelectorAll('img').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
        thumbs.appendChild(t);
      });
      thumbs.hidden = false;
    } else {
      thumbs.hidden = true;
    }
    var inCart = cart.items.some(function (l) { return l.handle === p.handle; });
    gpopSelect.textContent = inCart ? 'כבר בעגלה שלך' : 'הוספה לעגלה — ' + fmt(p.price);
    gpopSelect.disabled = inCart;
    gpop.hidden = false;
  }
  function openBundleInfo(handle) {
    var pr = prodCache[handle];
    if (!pr) return;
    var v = (pr.variants || [])[0] || {};
    openDealPopupBase({
      title: pr.title,
      image: (pr.images && pr.images[0]) || '',
      images: pr.images || [],
      descHtml: pr.description || '',
      worthText: v.compare_at_price ? '🎁 מתנה בשווי ' + fmt(v.compare_at_price) + ' — חינם עבורך!' : '🎁 מתנה — חינם עבורך!',
      btnText: 'סגירה',
      mode: { __closeOnly: true }
    });
  }
  function openBundleRemoveConfirm(key, handle) {
    var pr = prodCache[handle];
    var v = pr ? ((pr.variants || [])[0] || {}) : {};
    openDealPopupBase({
      title: pr ? pr.title : 'המתנה שלך',
      image: pr ? ((pr.images && pr.images[0]) || '') : '',
      images: [],
      descHtml: '<p style="text-align:center; font-weight:700;">רגע! המתנה הזו ניתנת לך בחינם עם המוצר.<br>בטוחים שאתם רוצים לוותר עליה?</p>',
      worthText: v.compare_at_price ? '🎁 מתנה בשווי ' + fmt(v.compare_at_price) + ' — בחינם!' : '🎁 מתנה בחינם',
      btnText: 'כן, הסירו את המתנה',
      secondaryText: 'לא, תשאירו לי אותה 💚',
      mode: { __bundleRemove: { key: key, handle: handle } }
    });
  }
  function openDealPopupBase(o) {
    gpopCurrent = o.mode;
    var mainImg = gpop.querySelector('.pcd-gpop-img');
    mainImg.src = o.image || '';
    gpop.querySelector('.pcd-gpop-title').textContent = o.title;
    gpop.querySelector('.pcd-gpop-worth').textContent = o.worthText;
    var desc = gpop.querySelector('.pcd-gpop-desc');
    desc.innerHTML = sanitizeHtml(o.descHtml || '');
    desc.classList.add('is-rich');
    var thumbs = gpop.querySelector('.pcd-gpop-thumbs');
    thumbs.innerHTML = '';
    var imgs = o.images || [];
    if (imgs.length > 1) {
      imgs.slice(0, 10).forEach(function (src, i) {
        var t = document.createElement('img');
        t.src = String(src).replace(/(\.[a-z]+)(\?|$)/, '_100x$1$2');
        t.className = i === 0 ? 'is-active' : '';
        t.addEventListener('click', function () {
          mainImg.src = src;
          thumbs.querySelectorAll('img').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
        thumbs.appendChild(t);
      });
      thumbs.hidden = false;
    } else { thumbs.hidden = true; }
    gpopSelect.textContent = o.btnText;
    gpopSelect.disabled = false;
    var sec = gpop.querySelector('.pcd-gpop-secondary');
    if (sec) { sec.hidden = !o.secondaryText; if (o.secondaryText) sec.textContent = o.secondaryText; }
    gpop.hidden = false;
  }
  function closeGiftPopup() { gpop.hidden = true; gpopCurrent = null; }
  gpop.addEventListener('click', function (e) {
    if (e.target.closest('[data-gpop-close]')) closeGiftPopup();
  });
  gpopSelect.addEventListener('click', function () {
    if (!gpopCurrent || gpopSelect.disabled) return;
    if (gpopCurrent.__closeOnly) { closeGiftPopup(); return; }
    if (gpopCurrent.__bundleRemove) {
      var br = gpopCurrent.__bundleRemove;
      closeGiftPopup();
      if (busy) return;
      var dd = bundleDismissed(); dd[br.handle] = 1; saveBundleDismissed(dd);
      busy = true; body.classList.add('pcd-loading');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: br.key, quantity: 0 })
      }).then(refresh).catch(refresh);
      return;
    }
    if (gpopCurrent.__deal) {
      var dp = gpopCurrent.__deal;
      closeGiftPopup();
      if (busy) return;
      busy = true; body.classList.add('pcd-loading');
      fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: dp.variant, quantity: 1 })
      }).then(refresh).catch(refresh);
      return;
    }
    var g = gpopCurrent;
    var selected = giftLines().some(function (l) { return String(l.variant_id) === String(g.variant); });
    closeGiftPopup();
    if (selected) removeGift(g); else addGift(g);
  });

  /* ---- חיווי גלילה ---- */
  var scrollHint = root.querySelector('.pcd-scroll-hint');
  function updateScrollHint() {
    var left = body.scrollHeight - body.clientHeight - body.scrollTop;
    scrollHint.classList.toggle('is-show', left > 60);
  }
  body.addEventListener('scroll', updateScrollHint, { passive: true });
  scrollHint.addEventListener('click', function () {
    body.scrollBy({ top: body.clientHeight * 0.75, behavior: 'smooth' });
  });

  /* ---- פתיחה/סגירה ---- */
  function open() {
    document.body.style.overflow = 'hidden';
    root.classList.add('is-open');
    refresh();
  }
  /* נפתחת מיד עם הלחיצה על "הוספה לסל", עוד לפני שהשרת ענה.
     בלי זה הלקוחה בוהה בכפתור מושבת שנייה שלמה ולא קורה כלום. */
  function openLoading() {
    document.body.style.overflow = 'hidden';
    root.classList.add('is-open');
    busy = true; body.classList.add('pcd-loading');
  }
  function close() {
    document.body.style.overflow = '';
    root.classList.remove('is-open');
    closeGiftPopup();
  }
  root.querySelector('.pcd-overlay').addEventListener('click', function () {
    if (!gpop.hidden) { closeGiftPopup(); return; }
    close();
  });
  root.querySelector('.pcd-close').addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!gpop.hidden) { closeGiftPopup(); return; }
    close();
  });
  document.addEventListener('click', function (e) {
    var t = e.target.closest('a[href$="/cart"], [data-open-cart]');
    if (!t) return;
    e.preventDefault();
    open();
  });
  window.PaphosCart = { open: open, openLoading: openLoading, close: close, refresh: refresh };
})();
